import React from 'react';
import { ViewStyle } from 'react-native';
import { AppRTCView } from '@/components/compose/call/rtc-view/app.rtc.view';
import { DeviceManager } from '@/webrtc/device-manager/device.manager';

interface Props {
  style?: ViewStyle;
  localStream: MediaStream | undefined;
  deviceManager: DeviceManager;
}
function BaseCameraView({ style, localStream, deviceManager }: Props) {
  return <AppRTCView deviceManager={deviceManager} zIndex={0} src={localStream} muted objectFit={'cover'} style={style} />;
}

export const CameraView = React.memo(BaseCameraView);
